export default "__VITE_ASSET__C6czBjeM__"